import React from 'react';
import { Alert } from '@mui/material';

export const WiviSyncNotice = ({ sx = {} }) => (
  <Alert severity="info" variant="outlined" sx={{ mb: 2, ...sx }}>
    Wivi inventory data on this page syncs about every 10 minutes. Signal data is only available for supported Fire 3 devices.
  </Alert>
);

export default WiviSyncNotice;